'use client';

import { Provider } from 'react-wrap-balancer';
import { DeferredToastProvider } from './components/DeferredToastProvider/DeferredToastProvider';
import { ThemeProvider } from '@frameio/vapor';

export function Providers({ children }: React.PropsWithChildren) {
  return (
    <ThemeProvider>
      <DeferredToastProvider>
        <Provider>{children}</Provider>
      </DeferredToastProvider>
    </ThemeProvider>
  );
}
